import React, { forwardRef, useImperativeHandle, useRef } from "react";
import styled from "styled-components";

const SwitchContainer = styled.div`
	.switch {
		position: relative;
		display: inline-block;
		width: 52px;
		height: 32px;
	}

	.switch input {
		opacity: 0;
		width: 0;
		height: 0;
		pointer-events: ${(props) => (props.checkable ? "auto" : "none")};
	}

	.slider {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		border-radius: 36px;
		background-color: var(--color-surface-highest);
		border: 2px solid var(--color-outline);
		transition: 0.3s;
	}

	.slider::before {
		position: absolute;
		content: "";
		height: 16px;
		width: 16px;
		top: 0;
		left: 6px;
		bottom: 0;
		margin: auto;
		border-radius: 50%;
		background-color: var(--color-outline);
		transition: 0.3s;
	}

	input:checked + .slider,
	input[checked] + .slider {
		background-color: var(--color-primary);
		border: none;
	}

	input:focus + .slider {
		box-shadow: 0 0 1px var(--color-primary);
	}

	input:checked + .slider::before,
	input[checked] + .slider::before {
		transform: translateX(18px);
		background-color: var(--color-on-primary);
		width: 24px;
		height: 24px;
		box-shadow: none !important;
	}

	.slider:hover::before {
		box-shadow: 0 0 6px var(--color-outline);
	}
`;

const Switch = forwardRef(
	({ check, checkable, onCheckChange = () => {} }, ref) => {
		const switchRef = useRef(null);

		const onCheckChangeHandler = (e) => {
			onCheckChange(e.target.checked);
		};

		useImperativeHandle(ref, () => ({
			setCheck: (check) => {
				switchRef.current.checked = check;
			},
			toggle: () => {
				switchRef.current.checked = !switchRef.current.checked;
			},
			isChecked: () => switchRef.current.checked,
		}));

		return (
			<SwitchContainer>
				<label className="switch">
					<input
						ref={switchRef}
						type="checkbox"
						defaultChecked={check}
						checkable={checkable}
						onChange={onCheckChangeHandler}
					/>
					<span className="slider" />
				</label>
			</SwitchContainer>
		);
	}
);

export default Switch;
